import React from 'react';
import './Terms.css';
import { useTranslation } from 'react-i18next';
const Terms = () => {
	const { t } = useTranslation();
	return <div className="terms"> {t('footer.terms')}</div>;
};

export default Terms;
